<template>
  <span>
    <v-form>
      <v-card flat max-width="800">
        <v-card-text>
          <v-text-field v-model="data.name" label="Наименование почты"></v-text-field>
          <v-text-field v-model="data.smtp_host" label="Сервер"></v-text-field>
          <v-text-field type="number" v-model="data.smtp_port" label="Порт"></v-text-field>
          <v-text-field v-model="data.smtp_user" label="Логин"></v-text-field>
          <v-text-field type="password" v-model="data.smtp_password" label="Пароль"></v-text-field>
          <v-select
              v-model="data.smtp_encryption"
              :items="encryptionTypes"
              :rules="[v => !!v || 'Необходимо выбрать тип шифрования']"
              label="Тип шифрования"
          >
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn
              color="success"
              class="mr-4"
              @click="save"
          >
              Сохранить
            </v-btn>
          <v-btn
              class="mr-4"
              @click="close"
          >
              Отмена
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </span>
</template>

<script>
export default {
  name: 'AccountEmailsDetails',
  props: {
    data: {}
  },
  data () {
    return {
      encryptionTypes: ['SSL', 'STARTTLS']
    }
  },
  mounted () {
  },
  methods: {
    close () {
      this.$emit('close')
    },
    save () {
      if (this.data.account_email_id === null) {
        this.axios.post('/api/account_emails/', this.data).then((response) => {
          this.data.account_email_id = response.data.account_email_id
          this.close()
        }).catch((err) => {
          console.log(err)
          this.loading = false
        })
      } else {
        this.axios.patch(`/api/account_emails/${this.data.account_email_id}/`, this.data).then(() => {
          this.close()
        }).catch((err) => {
          console.log(err)
          this.loading = false
        })
      }
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/spa/account-settings/AccountEmailsDetails.vue